import React from 'react';
import ClassNames from 'classnames';
import moment from 'moment-timezone';
import WindowListenable from 'mixins/js/WindowListeners';
import DateTime from 'utils/date-time';
import KeyCode from 'utils/key-code';
import CalendarMonth from 'components/date-picker/CalendarMonth';
import CalendarToolbar from 'components/date-picker/CalendarToolbar';
import DateDisplay from 'components/date-picker/DateDisplay';
import TimeDisplay from 'components/date-picker/TimeDisplay';
import Transition from 'components/transition-groups/Transition';

export default React.createClass({

	mixins: [ WindowListenable ],

	propTypes: {
		initialDate: React.PropTypes.object,
		isActive: React.PropTypes.bool,
		timeOffset: React.PropTypes.array,
		maxDate: React.PropTypes.object,
		minDate: React.PropTypes.object,
		timePicker: React.PropTypes.bool
	},

	windowListeners: {
		'keydown': '_handleWindowKeyDown'
	},

	getDefaultProps() {
		let initialDate = moment();
		return {
			initialDate: initialDate,
			maxDate: null,
			minDate: null,
			timePicker: true,
		};
	},

	getInitialState() {

		this._loadGMTTimezones();
		this._linkUserDefinedTimezones();

		let initialDate = this._setDefaultTimezone(moment(this.props.initialDate));
		let firstDayOfMonth = moment(initialDate);
		
		firstDayOfMonth.set("date" , 1 );
		
		return {
			displayDate: firstDayOfMonth,
			selectedDate: initialDate,
			rightNow: initialDate,
			calendarTransitionDirection: 'left',
			timeTransitionDirection: 'up',
			selectedUserTimeOffsetIndex: 0,
			rightNowActive: false
		};
	},

	componentWillUnmount() {

		clearInterval(this.clockInterval);

	},


	componentWillReceiveProps(nextProps) {

		if (nextProps.initialDate !== this.props.initialDate) {
			let d = nextProps.initialDate || moment();
			
			let firstDayOfMonth = moment(d);
			firstDayOfMonth.set("date" , 1 );

			this.setState({
				displayDate: firstDayOfMonth,
				selectedDate: this._setDefaultTimezone(d)
			});
		}
	},

	render() {
		let weekCount = DateTime.getWeekArray(this.state.displayDate).length,
			classes = ClassNames('lui-date-picker-calendar', {
				'lui-is-4week': weekCount === 4,
				'lui-is-5week': weekCount === 5,
				'lui-is-6week': weekCount === 6
			}),
			timeDisplay,
			timeDisplayLandscape,
			timeDisplayPortrait;

		if (this.props.timePicker) {
			timeDisplay = (
				<TimeDisplay 
					ref="timeDisplay"
					selectedTimeOffset={this.state.selectedTimeOffset} 
					transitionDirection={this.state.timeTransitionDirection}
					selectedDate={this.state.selectedDate} 
					onHourUp={this._addHour.bind(this, 1)} 
					onHourDown={this._addHour.bind(this, -1)} 
					onMinuteUp={this._addMinute.bind(this, 1)} 
					onMinuteDown={this._addMinute.bind(this, -1)} 
					onSecondUp={this._addSecond.bind(this, 1)} 
					onSecondDown={this._addSecond.bind(this, -1)} 
					onMeridiemUp={this._addHour.bind(this, 12)} 
					onMeridiemDown={this._addHour.bind(this, -12)}
					onTimezoneRight={this._addTimezone.bind(this, 1)} 
					onTimezoneLeft={this._addTimezone.bind(this, -1)} 
					minDate={this.props.minDate}
            		maxDate={this.props.maxDate} />
			);
		};

		if (this.props.mode == 'landscape') {
			timeDisplayLandscape = timeDisplay;
		} else if (this.props.mode == 'portrait' || 'inline') {
			timeDisplayPortrait = timeDisplay;
		}

		return (
			<div className={classes}>
				<DateDisplay
					className="lui-date-picker-calendar-date-display"
					selectedDate={this.state.selectedDate} 
					toggleTimeDisplay={this._handleToggleTimeDisplay} 
					timePicker={this.props.timePicker}
					nowButtonActive={this.state.rightNowActive}
					onNowButtonClick={this._handleNowButtonClick}/>
					{timeDisplayPortrait}

				<div className="lui-date-picker-calendar-container">
					<CalendarToolbar
						minDate={this.props.minDate}
            			maxDate={this.props.maxDate}
						displayDate={this.state.displayDate}
						onLeftTouchTap={this._handleLeftTouchTap}
						onRightTouchTap={this._handleRightTouchTap} />

					<ul className="lui-date-picker-calendar-week-title">
						<li className="lui-date-picker-calendar-week-title-day">S</li>
						<li className="lui-date-picker-calendar-week-title-day">M</li>
						<li className="lui-date-picker-calendar-week-title-day">T</li>
						<li className="lui-date-picker-calendar-week-title-day">W</li>
						<li className="lui-date-picker-calendar-week-title-day">T</li>
						<li className="lui-date-picker-calendar-week-title-day">F</li>
						<li className="lui-date-picker-calendar-week-title-day">S</li>
					</ul>

					<Transition
						direction={this.state.calendarTransitionDirection}>
						<CalendarMonth
							minDate={this.props.minDate}
            				maxDate={this.props.maxDate}
							key={this.state.displayDate.format('MMM DD YYYY')}
							displayDate={this.state.displayDate}
							onDayTouchTap={this._handleDayTouchTap}
							selectedDate={this.state.selectedDate} />
					</Transition>
				</div>
					{timeDisplayLandscape}
			</div>
		);
	},

	//////////////////
	// Get Methods //
	//////////////////

	getSelectedDate() {
		return this.state.selectedDate;
	},


	////////////
	// Time  //
	////////////

	_handleToggleTimeDisplay() {
		this.refs.timeDisplay.toggle();
	},

	_addHour(hours) {
		this._setSelectedDate(this.state.selectedDate.add(hours, "hours"));
		this.setState({
			timeTransitionDirection: hours > 0 ? 'up' : 'down'
		})
	},	

	_addMinute(minutes) {
		this._setSelectedDate(this.state.selectedDate.add(minutes, "minutes"));
		this.setState({
			timeTransitionDirection: minutes > 0 ? 'up' : 'down'
		})
	},	

	_addSecond(seconds) {
		this._setSelectedDate(this.state.selectedDate.add(seconds, "seconds"));
		this.setState({
			timeTransitionDirection: seconds > 0 ? 'up' : 'down'
		})
	},

	_startClock() {

		if (!this.state.rightNowActive) {
			this.clockInterval = setInterval(()=> {
				this._clockTick();
			}, 1000);
		};
	},

	_stopClock() {
		clearInterval(this.clockInterval);
	},

	_clockTick() {

		this.setState({
			rightNow: this._setDefaultTimezone(moment())
		});

		if (this.state.rightNowActive) {
			this._setSelectedDate(this.state.rightNow, true);
		};

	},

	///////////
	// Date //
	///////////

	_addDisplayDate(m) {
		let newDisplayDate = moment(this.state.displayDate);
		newDisplayDate.add(m, "months");
		this._setDisplayDate(newDisplayDate);
	},

	_addSelectedDays(days) {

		let newSelectedDate = moment(this.state.selectedDate);
		newSelectedDate.add(days, "days");
		

		if ( this.props.minDate !== null && newSelectedDate < this.props.minDate) {
			days = 0;
		}		

		if ( this.props.maxDate !== null && newSelectedDate > this.props.maxDate) {
			days = 0;
		}

		this._setSelectedDate(this.state.selectedDate.add(days, "days"));
	},

	_addSelectedMonths(months) {
		this._setSelectedDate(this.state.selectedDate.add(months, "months"));
	},

	_setDisplayDate(d, newSelectedDate, rightNow) {
		let newDisplayDate = moment(d);
		newDisplayDate.set("date", 1);

		let direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';

		if (newDisplayDate !== this.state.displayDate) {
			this.setState({
				displayDate: newDisplayDate,
				calendarTransitionDirection: direction,
				selectedDate: newSelectedDate || this.state.selectedDate,
				rightNowActive: rightNow ? true : false
			});
		}
	},

	_setSelectedDate(d, rightNow) {
		let newDisplayDate = moment(d);
		newDisplayDate.set("date", 1);

		rightNow ? this._startClock() : this._stopClock();

		if (newDisplayDate !== this.state.displayDate) {
			this._setDisplayDate(newDisplayDate, d, rightNow);
		} else {
			console.log('rightnow')
			this.setState({
				selectedDate: d,
				rightNowActive: rightNow ? true : false
			});
		};


	},

	////////////////
	// Timezones //
	////////////////

	_setDefaultTimezone(date) {
		
		let offset = date.utcOffset() / 60,
			userTimeOffset = this.props.timeOffset;

		if (userTimeOffset){
			let userOffset = userTimeOffset[0];
			date.tz(userOffset.name);

			return date;
		}
		
		if (offset === 0){
			offset = "+0";
		}

		if (offset > 0){
			offset = '+' + offset;
		}

		date.tz(`GMT${offset}`);

		return date

	},

	_setGMTTimezone(date, offset) {
		if (offset === 0){
			offset = "+0";
		}

		if (offset > 0){
			offset = '+' + offset;
		}

		if (offset > 12){
			offset = '+12';
		}

		if (offset < -14){
			offset = '-14';
		}

		date.tz(`GMT${offset}`);
		this._setSelectedDate(date);
	},

	_addTimezone(offset) {
		

		let { timeOffset } = this.props;
		let { selectedDate } = this.state;

		let currentOffset = selectedDate.utcOffset() / 60;

		if (timeOffset) {
			let index = this.state.selectedUserTimeOffsetIndex;

			index = index + offset;

			if (index >= timeOffset.length) {
				index = timeOffset.length - 1;
			};

			if (index < 0) {
				index = 0;
			};

			// Check Daylight Savings Time, and adjust accordingly

			if (moment([selectedDate.year(), selectedDate.month(), selectedDate.date()]).isDST()){
				let userOffset = parseInt(timeOffset[index].offset);

				if(timeOffset[index].DST) {
					userOffset += 1;
				};


				if (userOffset > 0){
					userOffset = '+' + userOffset;
				};

				moment.tz.link([`GMT${userOffset}|${timeOffset[index].name}`])
			};

			selectedDate.tz(`${timeOffset[index].name}`);
			
			this.setState({
				selectedUserTimeOffsetIndex: index
			});

			this._setSelectedDate(selectedDate);

			return;
		}

		offset = currentOffset + offset; 
		this._setGMTTimezone(selectedDate, offset)
	},

	_linkUserDefinedTimezones(){
		let { 
			timeOffset,
			initialDate } = this.props,
			linkArray = [];

			initialDate = moment(initialDate); 

		let DST = moment([initialDate.year(), initialDate.month(), initialDate.date()]).isDST() ? 1 : 0;

		timeOffset.forEach(function(object){
			
			if (object.DST === false) {
				DST = 0;
			};

			let userOffset = object.offset + DST;

			if (userOffset > 0){
				userOffset = '+'+userOffset;
			}

			let GMTOffset = `GMT${userOffset}`,
				linkString = `${GMTOffset}|${object.name}`;

				linkArray.push(linkString);	
		});

		moment.tz.link(linkArray)
	},

	_loadGMTTimezones() {
		moment.tz.add([
	    	"GMT+12|GMT+12|-c0|0|",
			"GMT+11|GMT+11|-b0|0|",
			"GMT+10|GMT+10|-a0|0|",
			"GMT+9|GMT+9|-90|0|",
			"GMT+8|GMT+8|-80|0|",
			"GMT+7|GMT+7|-70|0|",
			"GMT+5|GMT+5|-50|0|",
			"GMT+6|GMT+6|-60|0|",
			"GMT+4|GMT+4|-40|0|",
			"GMT+3|GMT+3|-30|0|",
			"GMT+2|GMT+2|-20|0|",
			"GMT+1|GMT+1|-10|0|",
			"GMT+0|GMT|0|0|",
			"GMT-1|GMT-1|10|0|",
			"GMT-2|GMT-2|20|0|",
			"GMT-3|GMT-3|30|0|",
			"GMT-4|GMT-4|40|0|",
			"GMT-5|GMT-5|50|0|",
			"GMT-6|GMT-6|60|0|",
			"GMT-7|GMT-7|70|0|",
			"GMT-8|GMT-8|80|0|",
			"GMT-9|GMT-9|90|0|",
			"GMT-10|GMT-10|a0|0|",
			"GMT-11|GMT-11|b0|0|",
			"GMT-12|GMT-12|c0|0|",
			"GMT-13|GMT-13|d0|0|",
			"GMT-14|GMT-14|e0|0|",
			"UCT|UCT|0|0|",
			"UTC|UTC|0|0|",
		]);
	},

	////////////////////
	// Event Handlers //
	////////////////////

	_handleDayTouchTap(e, date) {
		this._setSelectedDate(date);
	},

	_handleLeftTouchTap() {
		this._addDisplayDate(-1);
	},

	_handleRightTouchTap() {
		this._addDisplayDate(1);
	},

	_handleNowButtonClick() {
		this._setSelectedDate(this._setDefaultTimezone(moment()), !this.state.rightNowActive);
	},

	_handleWindowKeyDown(e) {
		let newSelectedDate;

		if (this.props.isActive) {

			switch (e.keyCode) {

				case KeyCode.UP:
					if (e.shiftKey) {
						this._addSelectedMonths(-1);
					} else {
						this._addSelectedDays(-7);
					}
					break;

				case KeyCode.DOWN:
					if (e.shiftKey) {
						this._addSelectedMonths(1);
					} else {
						this._addSelectedDays(7);
					}
					break;

				case KeyCode.RIGHT:
					if (e.shiftKey) {
						this._addSelectedMonths(1);
					} else {
						this._addSelectedDays(1);
					}
					break;

				case KeyCode.LEFT:
					if (e.shiftKey) {
						this._addSelectedMonths(-1);
					} else {
						this._addSelectedDays(-1);
					}
					break;

			};

		};
	},
});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/Calendar.js
 **/